import type {
  SchedulingConfiguration,
  SchedulingConfigurationInsert,
} from "@repo/app-types/entities/schedulingConfiguration";
import {
  TagType,
  getTagsInvalidatedByCreate,
  getTagsInvalidatedByUpdate,
  getTagsProvidedByEntity,
} from "../helpers/tags.js";
import { api } from "../redux.js";

const schedulingConfigurationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Scheduling Configuration endpoints
    schedulingConfigurationById: builder.query<SchedulingConfiguration, string>(
      {
        query: (id) => `/scheduling-configurations/${encodeURIComponent(id)}`,
        providesTags: (result, error, id) =>
          getTagsProvidedByEntity(TagType.SchedulingConfiguration, id),
      },
    ),
    updateSchedulingConfiguration: builder.mutation<
      SchedulingConfiguration,
      Partial<SchedulingConfiguration> & { id: string }
    >({
      query: ({ id, ...body }) => ({
        method: "PATCH",
        url: `/scheduling-configurations/${encodeURIComponent(id)}`,
        body,
      }),
      invalidatesTags: (result, error, { id }) =>
        getTagsInvalidatedByUpdate(TagType.SchedulingConfiguration, id),
    }),
    createSchedulingConfiguration: builder.mutation<
      SchedulingConfiguration,
      SchedulingConfigurationInsert
    >({
      query: (body) => ({
        method: "POST",
        url: "/scheduling-configurations",
        body,
      }),
      invalidatesTags: () =>
        getTagsInvalidatedByCreate(TagType.SchedulingConfiguration),
    }),
  }),
});

export const {
  useSchedulingConfigurationByIdQuery,
  useUpdateSchedulingConfigurationMutation,
  useCreateSchedulingConfigurationMutation,
} = schedulingConfigurationApi;
